<template>

<div>
  <!-- UNTUK PAYMENT DGN POINT -->
  <v-card v-if="poin == true" class="mr-5 cardDtl" max-width="150" elevation-0>
        <v-img
        height="80"
        width="80"
        class="mx-auto"
        :src="`data:image/png;base64,${product.iconSmall}`"
        lazy-src="@/assets/empty-img.png"
        ></v-img>

        <v-card-title
        class="text-caption"
        >{{ product.productName }}</v-card-title
        >

        <v-card-text >
        <div class="my-1 text-subtitle-1" style="background: pink; border-radius: 8px;">
            <span class="ml-1" style="color: #FFA800;">{{
            product.poin
            }}</span>
            <span> Poin</span>
        </div>
        </v-card-text>
    </v-card>

  <!-- UNTUK PAYMENT DGN UANG -->
  <v-card v-if="poin == false" class="mr-5 cardDtl" max-width="150" elevation-0>
        <v-img
        height="80"
        width="80"
        class="mx-auto"
        :src="`data:image/png;base64,${product.iconSmall}`"
        lazy-src="@/assets/empty-img.png"
        ></v-img>
        <div
        v-if="
            product.totalDiscount != null && product.totalDiscount != ''
        "
        >
            <v-chip class="shortChips" style="background: pink;">
                {{ product.totalDiscount }}
            </v-chip>
        </div>

        <v-card-title
        class="text-caption"
        >{{ product.productName }}</v-card-title
        >

        <v-card-text
        v-if="
            product.totalDiscount != null && product.totalDiscount != ''
        "
        >
            <div class="my-1 text-subtitle-1">
                <span class="text-decoration-line-through"
                >Rp.{{ humanFormat(product.priceProduct) }}</span>
                <br>
                <span class="ml-1 pinkText" style="color: ">{{
                product.price
                }}</span>
            </div>
        </v-card-text>
        <v-card-text v-else>
        <div class="my-1 text-subtitle-1">
            <span class="ml-1 pinkText" style="color: ">Rp. {{
            humanFormat(product.priceProduct)
            }}</span>
        </div>
        </v-card-text>
    </v-card>
</div>
</template>

<script>
export default {
props:['product','loadCards','poin']
}
</script>

<style scoped src="./Card.scss" lang="scss" />